import script from "./UploadProjectView.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadProjectView.vue?vue&type=script&setup=true&lang=js"

import "./UploadProjectView.vue?vue&type=style&index=0&id=b142ce04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b142ce04"]])

export default __exports__